import {
    setCookie,
    getCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import SplitType from 'split-type'

function smoothScroll(content, viewport, smoothness) {
    content = gsap.utils.toArray(content)[0];
    smoothness = smoothness || 1;

    gsap.set(viewport || content.parentNode, { overflow: "hidden", position: "fixed", height: "100%", width: "100%", top: 0, left: 0, right: 0, bottom: 0 });
    gsap.set(content, { overflow: "visible", width: "100%" });

    let getProp = gsap.getProperty(content),
        setProp = gsap.quickSetter(content, "y", "px"),
        setScroll = ScrollTrigger.getScrollFunc(window),
        removeScroll = () => content.style.overflow = "visible",
        killScrub = trigger => {
            let scrub = trigger.getTween ? trigger.getTween() : gsap.getTweensOf(trigger.animation)[0]; // getTween() was added in 3.6.2
            scrub && scrub.pause();
            trigger.animation.progress(trigger.progress);
        },
        height, isProxyScrolling;

    function refreshHeight() {
        height = content.clientHeight;
        content.style.overflow = "visible"
        document.body.style.height = height + "px";
        return height - document.documentElement.clientHeight;
    }

    ScrollTrigger.addEventListener("refresh", () => {
        removeScroll();
        requestAnimationFrame(removeScroll);
    })
    ScrollTrigger.defaults({ scroller: content });
    ScrollTrigger.prototype.update = p => p; // works around an issue in ScrollTrigger 3.6.1 and earlier (fixed in 3.6.2, so this line could be deleted if you're using 3.6.2 or later)

    ScrollTrigger.scrollerProxy(content, {
        scrollTop(value) {
            if (arguments.length) {
                isProxyScrolling = true; // otherwise, if snapping was applied (or anything that attempted to SET the scroll proxy's scroll position), we'd set the scroll here which would then (on the next tick) update the content tween/ScrollTrigger which would try to smoothly animate to that new value, thus the scrub tween would impede the progress. So we use this flag to respond accordingly in the ScrollTrigger's onUpdate and effectively force the scrub to its end immediately.
                setProp(-value);
                setScroll(value);
                return;
            }
            return -getProp("y");
        },
        scrollHeight: () => document.body.scrollHeight,
        getBoundingClientRect() {
            return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        }
    });

    return ScrollTrigger.create({
        animation: gsap.fromTo(content, { y: 0 }, {
            y: () => document.documentElement.clientHeight - height,
            ease: "none",
            onUpdate: ScrollTrigger.update
        }),
        scroller: window,
        invalidateOnRefresh: true,
        start: 0,
        end: refreshHeight,
        refreshPriority: -999,
        scrub: smoothness,
        onUpdate: self => {
            if (isProxyScrolling) {
                killScrub(self);
                isProxyScrolling = false;
            }
        },
        onRefresh: killScrub // when the screen resizes, we just want the animation to immediately go to the appropriate spot rather than animating there, so basically kill the scrub.
    });
}

var scrollObject;


function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}



const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    //initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('100px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        if (!isTouchDevice()) {
            document.querySelector('.site').classList.add('smooth');
            scrollObject = smoothScroll("#pageInner");
        } else {
            document.querySelector('.site').classList.remove('smooth');
        }



        if (getCookie('introAnim') == 1) {
            $('.intro').addClass('hide');
            $('.intro').removeClass('show');
            $('body').removeClass('showMenu');
            //  $('.intro').css('visibility', 'hidden');

        } else {
            $('.intro').addClass('hide2');
            $('.intro').removeClass('show');
            $('body').removeClass('showMenu');
            //$('.intro').css('visibility', 'hidden');

        }
        if (location.hash != '') {
            if (scrollObject) {
                const hash = location.hash;
                location.hash = '';
                const rect = document.querySelector(hash).getClientRects();
                $('html,body').css({ scrollTop: 0 }, 0);
                window.setTimeout(() => {
                    if ($(hash)) {
                        $('html,body').css({ scrollTop: 0 }, 0);
                        scrollObject.scroll(rect[0].y - 60);

                    }
                }, 400);



            }
        }

        document.querySelectorAll('a[href^="#"],a[href="' + location.pathname + '#"], a[href$="#contactForm"]').forEach(anchor => {
            let id = '';
            if (anchor.getAttribute('href').includes('#contactForm')) {
                id = 'contactForm';
            } else {
                let str = anchor.getAttribute('href').split('#');

                id = str[1].replace('#', '');
            }

            if (scrollObject) {


                const target = document.getElementById(id);
                if (target) {
                    const rect = target.getClientRects();
                    anchor.addEventListener('click', (e) => {
                        e.preventDefault();

                        scrollObject.scroll(rect[0].y - 80);
                        return false
                    });
                }
            } else {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    document.getElementById(id).scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            }
        });


        jQuery('a[href*="' + location.host + '"]:not([href$="#contactForm"]):not([href$=".jpg"]):not([href$=".jpeg"]):not([href$=".png"]):not([href$=".gif"]):not([href$=".pdf"]):not([href$=".txt"]):not([href$=".doc"]):not([href$=".docx"]):not([href$=".odt"]):not([href$=".odf"]):not([target="_blank"])')
            .click(function (e) {
                if (!e.ctrlKey) {
                    if (!$(this).parent().hasClass('active')) {
                        jQuery('.intro').css('visibility', 'visible');
                        jQuery('.intro').addClass('show');
                        jQuery('body').removeClass('showMenu');
                    }

                }
            });
        //   jQuery('.intro').addClass('hide');
        //   jQuery('.intro').removeClass('show');
        //   jQuery('body').removeClass('showMenu');

        window.onpageshow = function (event) {
            if (event.persisted) {
                jQuery('.intro').attr('style', '');
                jQuery('.intro').removeClass('show');
                // jQuery('body').removeClass('showMenu');
            }

        };

        document.querySelectorAll('.menu-item > a[href*="/#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {

                document.body.classList.remove('showMenu');
            });

        });




        $('.subpageHeader__goDown').click(function () {
            if (scrollObject) {
                console.log(scrollObject);
                $('html,body').css({ 'scrollTop': '0px' });
                scrollObject.scroll(1);
                window.setTimeout(() => {
                    scrollObject.scroll($(this).offset().top + $(this).height());
                }, 10);

            } else {
                $('html,body').animate({ 'scrollTop': ($(this).offset().top) + 'px' }, 500);
            }
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder').animate({ 'scrollTop': '0px' }, 0);
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (window.innerWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });



        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1600,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            });
        }
        if ($('.gProjectSlider__slider').length > 0) {
            $('.gProjectSlider__slider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1200,
                autoplaySpeed: 5000,
                appendArrows: $('.gProjectSlider__arrows'),
                fade: true,
                cssEase: 'linear'
            });
        }
        if ($('.gSlider__slider').length > 0) {
            $('.gSlider__slider').each(function () {
                $(this).slick({
                    infinite: $(this).parent().hasClass('st_2') ? true : false,
                    arrows: true,
                    dots: false,
                    autoplay: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    speed: 500,
                    autoplaySpeed: 5000,
                    appendArrows: $(this).parent().find('.gSlider__arrows'),
                    centerMode: $(this).parent().hasClass('st_2') ? true : false,
                    centerPadding: '0px',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
            });

        }






        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/olakosciow/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/olakosciow/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }

        if ($('.animHeader').length > 0) {

            var splitHeader = new SplitType('.animHeader', {
                split: 'lines',
                tagName: 'span',
            });

            $.each(splitHeader.lines, function (i, e) {
                $(e).wrapInner('<span></span>');
            });
            $('.animHeader').each(function () {
                gsap.fromTo($(this).find('.line span'), { opacity: 0, y: "100%" }, {
                    duration: 1,
                    opacity: 1,
                    y: "0%",
                    stagger: 0.1,
                    ease: "power1.out",
                    scrollTrigger: {
                        trigger: $(this),
                        start: 'top 80%',
                        //  markers: true,
                        toggleActions: 'play none none reverse',
                    },
                });

            });







        }


        if ($('.page-template-mainsite, .page-template-contact').length > 0) {

            var splitHeader = new SplitType('.subpageHeader__short, .subpageHeader__title', {
                split: 'lines',
                tagName: 'span',
            });

            $.each(splitHeader.lines, function (i, e) {
                $(e).wrapInner('<span></span>');
            });
            const headerAnim = gsap.timeline();
            headerAnim.fromTo('.subpageHeader__short .line span', { opacity: 0, y: "100%" }, {
                duration: 1,
                delay: 0.8,
                opacity: 1,
                y: "0%",
                stagger: 0.4,
                ease: "power2.out",
            });
            headerAnim.fromTo('.subpageHeader__title .line span', { opacity: 0, y: "100%" }, {
                duration: 1.4,
                delay: -0.4,
                opacity: 1,
                y: "0%",
                stagger: 0.1,
                ease: "power2.out",
            });
            //  headerAnim.fromTo('.subpageHeader__short', { opacity: 0 }, { duration: 1, delay: -0.5, opacity: 1 });


        } else {
            var splitHeader = new SplitType('.subpageHeader__title', {
                split: 'lines',
                tagName: 'span',
            });
            $.each(splitHeader.lines, function (i, e) {
                $(e).wrapInner('<span></span>');
            });
            const headerAnim = gsap.timeline();
            headerAnim.fromTo('.subpageHeader__title .line span', { opacity: 0, y: "100%" }, {
                duration: 2,
                delay: 1,
                opacity: 1,
                y: "0%",
                stagger: 0.4,
                ease: "power4.out",
            });
            headerAnim.fromTo('.subpageHeader__short', { opacity: 0 }, { duration: 1, delay: -0.5, opacity: 1 });

        }



        gsap.fromTo('.subpageHeader__bgImage, .subpageHeader .rotator', {
            y: 0,
        }, {
            y: "60%",
            ease: "none",
            scrollTrigger: {
                trigger: '.subpageHeader',
                start: 'top top',
                end: 'bottom top',
                scrub: true,
                //markers: true
            },
        });


        let columns_anim_stripe = $('.columns_anim_stripe');
        if (columns_anim_stripe.length > 0 && window.innerWidth > 782) {
            columns_anim_stripe.append('<div class="stripe"></div>');


            gsap.fromTo(columns_anim_stripe.find('.stripe'), {
                y: "-30%",
            }, {
                y: "50%",
                ease: "none",
                scrollTrigger: {
                    trigger: columns_anim_stripe,
                    start: 'top 50%',
                    end: 'bottom 50%',
                    scrub: true,
                    //   markers: true
                },
            });
        } else if (columns_anim_stripe.length > 0) {
            columns_anim_stripe.addClass('animUp');
        }
        if ($('.columns_anim_stripe + .wp-block-heading').length > 0) {
            gsap.fromTo($('.columns_anim_stripe + .wp-block-heading'), {
                opacity: 0,
                ease: "power4.out",
            }, {
                opacity: 1,
                scrollTrigger: {
                    trigger: columns_anim_stripe,
                    start: 'bottom 50%',
                    //markers: true,
                    toggleActions: 'play none none reverse',
                },
            });

        }










        const animList = document.querySelectorAll('.animUp');

        if (animList.length > 0) {
            [...animList].forEach((item) => {
                gsap.fromTo(item, {
                    opacity: 0,
                    y: 30,
                }, {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    easing: "power1.out",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 55%",
                        //  end: "bottom bottom",
                        // scrub: true,
                        //markers: true,
                        // once: true,
                    },
                });

            });
        }
        const animListRight = document.querySelectorAll('.animRight');

        //anim righ
        if (animListRight.length > 0) {
            [...animListRight].forEach((item) => {
                gsap.fromTo(item, {
                    opacity: 0,
                    x: 30,
                }, {
                    opacity: 1,
                    x: 0,
                    duration: 0.8,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 85%",
                        //  end: "bottom bottom", 
                        // scrub: true,
                        // markers: true,
                        // once: true,
                    },
                });

            });
        }
        const animListLeft = document.querySelectorAll('.animLeft');

        //anim righ
        if (animListLeft.length > 0) {
            [...animListLeft].forEach((item) => {
                gsap.fromTo(item, {
                    opacity: 0,
                    x: -30,
                }, {
                    opacity: 1,
                    x: 0,
                    duration: 1.2,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 75%",
                        //  end: "bottom bottom", 
                        // scrub: true,
                        // markers: true,
                        // once: true,
                    },
                });

            });
        }


        const mediaBlocks = document.querySelectorAll('.wp-block-media-text__media img');

        if (mediaBlocks.length > 0) {


            mediaBlocks.forEach((img) => {
                gsap.fromTo(img, {
                    y: "-40%",
                }, {
                    y: "0%",
                    ease: "none",
                    scrollTrigger: {
                        trigger: img,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        //markers: true,
                    },
                });
            });
        }


        const paralaxImages = document.querySelectorAll('.paralax_image img, .paralax_image_grid img');

        if (paralaxImages.length > 0) {
            paralaxImages.forEach((img) => {
                const containerHeight = img.offsetHeight;

                img.parentElement.style.height = `${containerHeight}px`;
                img.style.height = `${containerHeight * 1.4}px`;
                if (img.parentElement.classList.contains('paralax_image_grid')) {
                    img.parentElement.classList.add('paralax_image');
                }
                gsap.fromTo(img, {
                    y: "-40%",
                }, {
                    y: "0%",
                    ease: "none",
                    scrollTrigger: {
                        trigger: img,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        //  markers: true,
                    },
                });
            });
        }
        const paralaxImagesRev = document.querySelectorAll('.paralax_image_revert img');

        if (paralaxImagesRev.length > 0) {
            paralaxImagesRev.forEach((img) => {
                const containerHeight = img.offsetHeight;
                img.parentElement.style.height = `${containerHeight}px`;
                img.style.height = `${containerHeight * 1.4}px`;
                gsap.fromTo(img, {
                    y: "0%",
                }, {
                    y: "-30%",
                    ease: "none",
                    scrollTrigger: {
                        trigger: img,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        // markers: true,
                    },
                });
            });
        }





        function shuffleElements(container) {
            const elements = container.children;
            for (let i = elements.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                container.appendChild(elements[j]);
            }
        }

        /*  function shuffleAllContainers(selector, interval) {
              const containers = document.querySelectorAll(selector);
              containers.forEach((container) => {
                  let shuffleInterval;
                  container.addEventListener('mouseenter', () => {
                      shuffleInterval = setInterval(() => shuffleElements(container), interval);
                  });
                  container.addEventListener('mouseleave', () => {
                      clearInterval(shuffleInterval);
                  });
              });
          }*/
        /* function shuffleAllContainers(selector, interval) {
             const containers = document.querySelectorAll(selector);
             containers.forEach((container) => {
                 setInterval(() => shuffleElements(container), interval);
             });
         }*/

        function shuffleAllContainers(selector, interval) {
            const containers = document.querySelectorAll(selector);
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            };

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const container = entry.target;
                        const shuffleInterval = setInterval(() => shuffleElements(container), interval);
                        entry.target._shuffleInterval = shuffleInterval;
                    } else {
                        clearInterval(entry.target._shuffleInterval);
                    }
                });
            }, observerOptions);

            containers.forEach(container => {
                observer.observe(container);
            });
        }

        shuffleAllContainers('.shufle_elements', 1000); // Zmień na odpowiednią klasę kontenera



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



